/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'caution': {
    width: 41,
    height: 40,
    viewBox: '0 0 41 40',
    data: '<g clip-path="url(#clip0_10649_28986)" _fill="#1F222C"><path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M20.164 1l19.663 37.014H.5L20.164 1zM3.827 36.014H36.5L20.164 5.263 3.827 36.013z"/><path pid="1" d="M18.143 17.11a2.238 2.238 0 114.466.093l-.743 8.906a1.5 1.5 0 01-1.494 1.375h-.358a1.5 1.5 0 01-1.498-1.437l-.373-8.938zM22.281 30.661a2.118 2.118 0 11-4.235 0 2.118 2.118 0 014.235 0z"/></g><defs><clipPath id="clip0_10649_28986"><path pid="2" _fill="#fff" transform="translate(.5)" d="M0 0h40v40H0z"/></clipPath></defs>'
  }
})
